import { render, staticRenderFns } from "./OsaFooter.vue?vue&type=template&id=1bcbb61d&scoped=true&"
import script from "./OsaFooter.vue?vue&type=script&lang=ts&"
export * from "./OsaFooter.vue?vue&type=script&lang=ts&"
import style0 from "./OsaFooter.vue?vue&type=style&index=0&id=1bcbb61d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcbb61d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1bcbb61d', component.options)
    } else {
      api.reload('1bcbb61d', component.options)
    }
    module.hot.accept("./OsaFooter.vue?vue&type=template&id=1bcbb61d&scoped=true&", function () {
      api.rerender('1bcbb61d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/common/components/OsaFooter.vue"
export default component.exports